import { render, staticRenderFns } from "./commercialTenant.vue?vue&type=template&id=46284a7d"
import script from "./commercialTenant.vue?vue&type=script&lang=js"
export * from "./commercialTenant.vue?vue&type=script&lang=js"
import style0 from "./commercialTenant.vue?vue&type=style&index=0&id=46284a7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports